import { useTranslation } from 'react-i18next'
import ErrorPage from './ErrorPage'

export default function NotFound() {
  const { t } = useTranslation()

  return (
    <ErrorPage
      status={404}
      title={t('errors.pages.404.title')}
      message={t('errors.pages.404.message')}
      showHomeButton={true}
      showBackButton={true}
    />
  )
}
